import { render, staticRenderFns } from "./expenses-general.vue?vue&type=template&id=254fdd34"
import script from "./expenses-general.vue?vue&type=script&lang=js"
export * from "./expenses-general.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports